"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PivotTransform_1 = require("./PivotTransform");
var CollectionTransform_1 = require("./CollectionTransform");
var AliasTransform_1 = require("./AliasTransform");
var CaseTransform_1 = require("./CaseTransform");
var SplitTransform_1 = require("./SplitTransform");
var FilterTransform_1 = require("./FilterTransform");
var ConditionalTransform_1 = require("./ConditionalTransform");
var SwitchTransform_1 = require("./SwitchTransform");
var NumberTransform_1 = require("./NumberTransform");
var VisibleTransform_1 = require("./VisibleTransform");
var TrimTransform_1 = require("./TrimTransform");
var Transform = /** @class */ (function () {
    function Transform(options, translationHelper) {
        this.options = options;
        this.translationHelper = translationHelper;
    }
    Transform.prototype.execute = function (queryResponse, queryOptions, executionOptions) {
        var transformOptionsType = this.options.transformOptionsType;
        var transform;
        if (transformOptionsType) {
            switch (transformOptionsType) {
                case 'pivot':
                    transform = new PivotTransform_1.PivotTransform(this.options, this.translationHelper);
                    break;
                case 'collection':
                    transform = new CollectionTransform_1.CollectionTransform(this.options, this.translationHelper);
                    break;
                case 'alias':
                    transform = new AliasTransform_1.AliasTransform(this.options, this.translationHelper);
                    break;
                case 'case':
                    transform = new CaseTransform_1.CaseTransform(this.options, this.translationHelper);
                    break;
                case 'split':
                    transform = new SplitTransform_1.SplitTransform(this.options, this.translationHelper);
                    break;
                case 'filter':
                    transform = new FilterTransform_1.FilterTransform(this.options, this.translationHelper);
                    break;
                case 'conditional':
                    transform = new ConditionalTransform_1.ConditionalTransform(this.options, this.translationHelper);
                    break;
                case 'switch':
                    transform = new SwitchTransform_1.SwitchTransform(this.options, this.translationHelper);
                    break;
                case 'number':
                    transform = new NumberTransform_1.NumberTransform(this.options, this.translationHelper);
                    break;
                case 'visible':
                    transform = new VisibleTransform_1.VisibleTransform(this.options, this.translationHelper);
                    break;
                case 'trim':
                    transform = new TrimTransform_1.TrimTransform(this.options, this.translationHelper);
                    break;
                default:
                    transform = undefined;
                    break;
            }
            if (transform) {
                var transformResponse = transform.execute(queryResponse, queryOptions, executionOptions);
                return transformResponse;
            }
        }
    };
    return Transform;
}());
exports.Transform = Transform;
//# sourceMappingURL=Transform.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@kurtosys/ksys-app-template/dist/query/transform/Transform.js
// module id = 366
// module chunks = 1